//Library Imports
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import store, { RootState } from "store";

//Local imports
import { Row, Col } from "antd";
import KeywordSource from "./KeywordSource";
import FooterActionButton from "./FooterActionButton";
import NewCampaignModule from "./NewCampaignModule";
import Input from "../../../Common/Components/Input";
import DownAngle from "../../../../assets/img/icons/DownAngle.svg";
import Temp from "../../../../assets/img/template.svg";
import CustomSelectAsset from "modules/Design/Assets/CustomSelectAsset";
import { ICampaignsName } from "modules/Campaigns/interfaces";
import { saveAdHocAssetAPI, saveAdHocAssetAPIAndCampaign } from "../actions";

//Style imports
import styled from "styled-components";
import { ADHOC } from "constants/types";
import { closeOverlay } from "modules/GlobalActions";

type CreateAssetAsiderProps = {
  templateAsider: boolean;
  campaignItems: ICampaignsName[];
  selectedCampaign: number;
  handleSelectedCampaign?: any;
  onClickCancel?: any;
  onClickCreateCampaign?: any;
  showTemplatesBrowser?: any;
  setToggleAssetNameEdit?: any;
  setAssetName?: any;
  selectedTemplateName: string;
  assetName: string;
  selectedTemplateImage: string;
  toggleAssetNameEdit: string;
  toggleDisable: string;
  selectedTemplateId: number;
  setToggleDisabled?: any;
  handleAdhocNameInput?: any;
  showCampaignAsider?: boolean;
  handleCampaignName?: any;
  handleOnClickBrowsePeople?: any;
  onClickAudienceDone?: any;
  setSelectedContactNames?: (value: any[]) => void;
  setSelectedContactIds?: (value: any[]) => void;
  selectedContactNames?: string[];
  selectedContactIds?: any[];
  setSelectedListIds?: (value: any[]) => void;
  setSelectedListNames?: (value: any[]) => void;
  setCreateAdHocAsset: (value: boolean) => void;
  selectedListNames?: string[];
  selectedListIds?: any[];
  handleAddPeople?: any;
  campaignKeywords?: any[];
  setCampaignKeywords?: any;
  handleOnRemoveCampaignKeyword?: any;
  handleAddSearchTerm?: any;
  campaignName?: any;
  assetType?: any;
  loadMore?: any
  loadingCampaigns?: boolean;
};

const CreateAssetAsider: React.FC<CreateAssetAsiderProps> = (props: CreateAssetAsiderProps) => {
  const {
    campaignItems,
    selectedCampaign,
    handleSelectedCampaign,
    onClickCreateCampaign,
    onClickCancel,
    showTemplatesBrowser,
    selectedTemplateName,
    selectedTemplateImage,
    assetName,
    toggleAssetNameEdit,
    toggleDisable,
    selectedTemplateId,
    campaignName,
    handleAdhocNameInput,
    showCampaignAsider,
    handleCampaignName,
    handleOnClickBrowsePeople,
    selectedListIds,
    selectedListNames,
    handleAddPeople,
    campaignKeywords,
    setCampaignKeywords,
    handleOnRemoveCampaignKeyword,
    assetType,
    selectedContactNames,
    selectedContactIds,
    setCreateAdHocAsset,
    loadMore,
    loadingCampaigns
  } = props;
  const history = useHistory();
  const redirectUrl = useSelector((state: RootState) => state.adHocTemplates.redirectUrl);
  function saveAdHocAsset() {
    // Save selected template with asset
    if (showCampaignAsider) {
      saveAdHocAssetAPIAndCampaign(
        assetName,
        campaignName,
        campaignKeywords,
        selectedContactIds,
        selectedListIds,
        selectedTemplateId
      );
    } else {
      saveAdHocAssetAPI(selectedCampaign, assetName, selectedTemplateId);
    }
  }
  useEffect(() => {
    if (redirectUrl) {
      let url = redirectUrl;
      store.dispatch({
        type: ADHOC.RESET_URL,
        redirectUrl: "",
      });
      history.push(url);
      closeOverlay();
      setCreateAdHocAsset(false);
    }
  }, [redirectUrl]);
  return (
    <Wrapper className="wrapper-campaign-keyword open">
      <div className="create-campaign-wrapper-two">
        <h1 className="create-campaign-heading">
          Create New
          <br />
          Email
        </h1>
        <div className="scroll-Wrapper-two">
          <div className={`edit-wrapper-two ${toggleAssetNameEdit}`}>
            {/* Toggle editable-active class */}
            <span className="name-two">
              <h2 id="asset_name" className="asset-name-two new-campaign">
                {"Name your new email"}
              </h2>
              <div className="editable">
                <Input
                  type="text"
                  label="Name your new Email"
                  placeholder="Give your email a name"
                  onChange={(e: any) => handleAdhocNameInput(e, "name")}
                  value={assetName}
                  idInput="email-name-input-adhoc"
                />
              </div>
            </span>
          </div>
          <KeywordSource
            heading="Select a template for this Ad hoc email"
            showInput={false}
            placeholder=""
            desc=""
          >
            <span className="test" onClick={showTemplatesBrowser} id="browse-adhoc-templates">
              Browse
            </span>
          </KeywordSource>
          <div className="template-row align-items-center d-flex py-3">
            <div>
              <img src={selectedTemplateImage !== "" ? selectedTemplateImage : Temp} alt="" />
            </div>
            <div className="ps-3 text-desc">
              <h4 className="main-title" id="selected-template-name">
                {selectedTemplateName !== "" ? selectedTemplateName : "No template selected"}
              </h4>
              <p>
                Click Browse above to view our pre-built templates, your custom templates, and templates shared
                with you. You can also create your own template from scratch…
              </p>
            </div>
          </div>
          <Row gutter={26} className="mt-4">
            <Col className="gutter-row py-3" span={24}>
              <h4 className="main-title mb-1">Save email to a Campaign</h4>
              <CustomSelectAsset
                campaigns_list={campaignItems}
                campaignName={"Please select..."}
                selectedValue={
                  showCampaignAsider
                    ? "Create new campaign"
                    : campaignItems?.find((item) => selectedCampaign?.toString() === item?.campaign_id?.toString())
                      ?.name
                }
                setCampaignName={(value: string) => {
                  "user";
                }}
                setSelectedCampaign={handleSelectedCampaign}
                onClickCreateCampaign={(value: any) => {
                  onClickCreateCampaign(value);
                }}
                loadMore={() => loadMore && loadMore()}
                loadingCampaigns={loadingCampaigns}
              />
            </Col>
          </Row>
          <div className={showCampaignAsider ? "new-campaign-bottom" : "d-none"}>
            <NewCampaignModule
              handleCampaignNameInput={handleCampaignName}
              campaignName={campaignName}
              handleOnClickBrowsePeople={handleOnClickBrowsePeople}
              // onClickAudienceDone={onClickAudienceDone}
              selectedContactIds={selectedContactIds}
              selectedContactNames={selectedContactNames}
              selectedListIds={selectedListIds}
              selectedListNames={selectedListNames}
              handleAddPeople={handleAddPeople}
              handleOnRemoveCampaignKeyword={handleOnRemoveCampaignKeyword}
              campaignKeywords={campaignKeywords}
              setCampaignKeywords={setCampaignKeywords}
              assetType={assetType}
              saveAsAsset={false}
            />
          </div>
        </div>
      </div>
      <FooterActionButton>
        <span className="footer-btn mr" onClick={onClickCancel} id="cancel-email-adhoc">
          Cancel
        </span>
        <span className={`footer-btn filled-success ${toggleDisable}`} onClick={saveAdHocAsset}
          id="save-email-adhoc">
          Save
        </span>
      </FooterActionButton>
    </Wrapper>
  );
};

export default React.memo(CreateAssetAsider);

const Wrapper = styled.div`
  transition: ease all 0.1s;
  box-sizing: border-box;
  height: 100vh;
  overflow-y: auto;
  width: 0px;
  background-color: #fff;
  position: relative;
  min-width: 100%;
  transition: ease all 0.1s;
  overflow: hidden;
  padding: 42px 40px 29px 40px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding: 30px 20px 30px 20px;
  }
  &.open {
    max-width: 530px;
    width: 100%;
    transition: ease all 0.1s;
    overflow: hidden;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      max-width: 410px;
    }
  }
  @media all and (max-height: 1439px) and (min-height: 600px) {
    justify-content: space-between;
    align-items: center;
    .btn-wrapper {
      display: flex;
      align-items: center;
      .ml {
        margin-left: 12px;
      }
    }
  }
  .template-row {
    .text-desc {
      @media all and (min-width: 1439px) {
        padding-right: 55px;
      }
    }
    img {
      max-width: 100%;
      min-width: 100px;
    }
    h4.main-title {
      font-family: "Roboto Slab", serif;
      font-weight: 500;
      color: #5e7079 !important;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 13px;
      }
    }
    p {
      color: #5e7079;
      font-size: 14px;
      font-weight: 400;
      font-family: "Roboto", sans-serif;
      margin: 0;
      white-space: pre-wrap;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 10px;
      }
    }
  }
  .dec-paragraph.mb {
    margin: 8px 0 10px 0 !important;
  }
  .main-title {
    color: #5e7079 !important;
    font-size: 18px;
    font-weight: 600;
    font-family: "Roboto", sans-serif;
    margin: 0;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 13px;
    }
  }
  .select-dropdown {
    width: 100%;
    .ant-select-selector {
      border: 1px solid #dadada;
      border-radius: 8px;
      background-color: #fff;
      color: #7e7e7e;
      font-family: "Roboto", sans-serif;
      font-size: 16px;
      font-weight: 500;
      padding: 5px 13px;
      width: 100%;
      margin-top: 6px;
    }
    .ant-select-arrow {
      background-image: url(${DownAngle});
      background-repeat: no-repeat;
      background-position: 8px 8px;
      border-left: 1px solid #dddddd;
      padding-left: 10px;
      margin-left: 10px;
      min-width: 22px;
      min-height: 22px;
      vertical-align: 0;
      top: 40%;
      span {
        opacity: 0;
      }
    }
  }
  .asset-name-two {
    text-overflow: ellipsis;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    float: left;
    max-width: 700px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      max-width: 445px;
    }
  }
  .name-two {
    color: rgb(155, 155, 155);
    position: relative;
    float: left;
    display: flex;
    align-items: center;
    width: 100%;
    .tooltip {
      position: relative;
      display: inline-block;
      opacity: 1;
      z-index: 0;
      .tooltiptext {
        color: #ffffff;
        font-size: 11px;
        letter-spacing: 0.02px;
        line-height: 15px;
        text-align: center;
        background-color: #263153;
        visibility: hidden;
        border-radius: 4px;
        padding: 5px 0;
        position: absolute;
        z-index: 1;
        bottom: 125%;
        left: 50%;
        transform: translateX(-50%);
        opacity: 0;
        transition: opacity 0.3s;
        padding: 5px 10px;
        &:after {
          content: "";
          position: absolute;
          top: 100%;
          left: 50%;
          margin-left: -5px;
          border-width: 5px;
          border-style: solid;
          border-color: #263153 transparent transparent transparent;
        }
      }
      &:hover .tooltiptext {
        visibility: visible;
        opacity: 1;
      }
    }
    .asset-name-two {
      text-overflow: ellipsis;
      display: block;
      overflow: hidden;
      white-space: nowrap;
      float: left;
      max-width: 700px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        max-width: 445px;
      }
    }
    &.editable-active {
      .editable {
        display: block;
      }
    }
    .editable {
      position: absolute;
      top: 45px;
      left: 0;
      width: 100%;
      display: none;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        top: 25px;
      }
      label {
        display: none;
      }
      input {
        padding-right: 70px;
      }
      .save {
        position: absolute;
        top: 9px;
        right: 10px;
        height: 100%;
        cursor: pointer;
        img {
          vertical-align: middle;
          max-width: 20px;
        }
      }
      .cancel {
        position: absolute;
        top: 9px;
        right: 40px;
        height: 100%;
        cursor: pointer;
        img {
          vertical-align: middle;
          max-width: 20px;
          padding: 2px;
        }
      }
    }
    .edit-btn {
      cursor: pointer;
      margin-left: 10px;
    }
  }
  .scroll-Wrapper-two {
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 230px);
    box-sizing: border-box;
    height: 100%;
    .search-terms-wrap {
      .wrapper-content {
        flex-direction: row;
        align-items: baseline;
      }
    }
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    ::-webkit-scrollbar {
      display: none;
    }
    scrollbar-width: thin;
    scrollbar-color: #001760 #efefef;
    &::-webkit-scrollbar {
      width: 5px;
      height: 5px;
      border-radius: 5px;
    }
    /* Track */
    &::-webkit-scrollbar-track {
      background: #fff;
      margin-top: 10px;
      margin-bottom: 15px;
    }
    /* Handle */
    &::-webkit-scrollbar-thumb {
      background: #001760;
    }
    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover {
      background: #555;
    }
  }
  .create-campaign-wrapper-two {
    position: relative;
    height: 100%;
    .create-campaign-heading {
      color: #424b50;
      font-size: 46px;
      font-weight: 800;
      line-height: 48px;
      margin-bottom: 0px;
      display: block;
      font-family:'Roboto Slab', serif;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        font-size: 32px;
        line-height: 40px;
      }
    }
    .edit-wrapper-two {
      display: flex;
      margin-top: 20px;
      margin-bottom: 65px;
      padding: 0 2px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        margin-top: 10px;
        margin-bottom: 50px;
      }
      .new-campaign {
        color: #5e7079;
        font-size: 20px;
        line-height: 47px;
        margin-bottom: 0px;
        display: inline-block;
        font-family: "Roboto", sans-serif;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 14px;
          line-height: 24px;
        }
      }
      .edit-icon {
        margin-left: 10px;
        cursor: pointer;
      }
      &.editable-active {
        .editable {
          display: block;
        }
      }
    }
  }
`;
